export const formatTrendPercent = (
  value: string | number | null | undefined,
) => {
  if (value === null || value === undefined) return null;

  const raw = String(value).trim();
  if (!raw) return null;
  if (!/[0-9]/.test(raw)) return raw;

  const sign = raw.startsWith("-") || raw.startsWith("+") ? raw[0] : "";
  let numeric = sign ? raw.slice(1) : raw;
  numeric = numeric.replace(/%/g, "").trim();

  if (!numeric) return `${sign}0%`;

  if (numeric.includes(".")) {
    const [intPartRaw, decPartRaw] = numeric.split(".");
    const intPart = intPartRaw.replace(/^0+(?=\d)/, "") || "0";
    numeric = `${intPart}.${decPartRaw}`;
  } else {
    numeric = numeric.replace(/^0+(?=\d)/, "");
  }

  return `${sign}${numeric}%`;
};

export const formatPercentValue = (
  value: number | null | undefined,
  decimals = 2,
  includeSymbol = true,
) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return includeSymbol ? "0.00%" : "0.00";
  }
  const formatted = value.toFixed(decimals);
  return includeSymbol ? `${formatted}%` : formatted;
};
